// extracted by mini-css-extract-plugin
module.exports = {"container":"calendar__container___22GTG"};